import { Autocomplete as MAutocomplete, AutocompleteProps } from '@mui/material'

export const Autocomplete = <T,>({
  ...props
}: AutocompleteProps<T, boolean, boolean, boolean, React.ElementType>) => {
  return <MAutocomplete {...props} />
}
